export const loadItem = (name: string): any => {
    try {
        const serializedItem = localStorage.getItem(name);
        if (serializedItem === null) {
            return undefined;
        }
        return JSON.parse(serializedItem);
    } catch (err) {
        return undefined;
    }
};

export const saveItem = (name: string, item: any): void => {
    try {
        const serializedItem = JSON.stringify(item);
        localStorage.setItem(name, serializedItem);
    } catch (err) {
        console.warn(err);
    }
};

export const deleteItem = (name: string): void => {
    try {
        localStorage.removeItem(name);
    } catch (err) {
        console.warn(err);
    }
};

export const deleteAll = (): void => {
    localStorage.clear();
};
